import Vue from 'vue'
import App from './components/App/App.vue'
import router from './router'
import store from './vuex/store'
import Axios from 'axios'
import './assets/scss/main.scss'
import './imports/components'
import VueLazy from 'vue-lazyload'
const VueGoogleMaps = require('vue2-google-maps')
import ScrollMagic from 'ScrollMagic'
import VueScrollTo from 'vue-scrollto'
import TweenMax from 'TweenMax'
import 'animation.gsap'

window.scrollController = new ScrollMagic.Controller()

Vue.config.productionTip = false

window.Vue = Vue

Vue.use(VueLazy, {
  preLoad: 1,
  observer: true,
  lazyComponent: true,

  // optional
  observerOptions: {
    rootMargin: '-150px',
    threshold: 0
  }
})

window.api = Axios.create({
  baseURL: 'https://api.alt-design.net/api/'
})

Vue.prototype.$getField = (key, children) => {
  children = children.children
  for (let part of Object.keys(children)) {
    part = children[part]
    if (part.field.key === key) {
      if (part.field.type === 'image' && part.field.value && part.field.value.indexOf('data:image') > -1) {
        return 'get-image-' + part.field.id
      }
      return part.field.value
    }
  }
}

Vue.prototype.$getFieldValue = (key, children) => {
  children = children.children
  for (let part of Object.keys(children)) {
    part = children[part]
    if (part.field.key === key) {
      if (part.field.type === 'image' && part.field.value && part.field.value.indexOf('data:image') > -1) {
        return 'get-image-' + part.field.id
      }
      return part.field.id
    }
  }
}

Vue.prototype.$relativeUrl = url => {
  return url.replace(store.state.url, '')
}

Vue.prototype.$setSeo = (title, desc) => {
  document.title = title
  document.querySelector('meta[name="description"]').setAttribute('content', desc)
}

Vue.prototype.$setTweens = () => {
  for (let scene of store.state.currentScenes) {
    scene.destroy()
  }

  store.commit('resetScenes')

  const slides = document.querySelectorAll('.animateIn')

  for (let slide of slides) {
    let newScene = new ScrollMagic.Scene({
      triggerElement: slide,
      triggerHook: 'onEnter',
      offset: -200

    })
      .setTween(TweenMax.from(slide, 1, {y: 250, opacity: 0}))
      .addTo(window.scrollController)
    TweenMax.lagSmoothing(33, 1)

    store.commit('addScene', newScene)
  }
}

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyArRypsFz6V-a5aFySuvo66PZ5ekkAT8js'
  }
})

Vue.use(VueScrollTo)

/* eslint-disable no-new */
var root = new Vue({
  router,
  store,
  render: h => h(App)
})

document.addEventListener('DOMContentLoaded', function () {
  root.$mount('#app')
})



// WEBPACK FOOTER //
// ./src/main.js